<template>
  <div class="login2">
    <img class="topbg" src="/static/images/logintop.png" alt />
    <img class="middlebg" src="/static/images/login1.png" alt />
    <!-- <img class="bottombg" v-show="pageheight>450" :data=pageheight src="/static/images/loginbottom.png" alt=""> -->
    <div class="maincont">
      <div class="part1">
        <span class="theme-bg"></span>
        <h2 class="theme-col">欢&#8194;迎&#8194;来&#8194;到</h2>
        <h3 class="theme-col">产&#8194;品&#8194;兑&#8194;换&#8194;专&#8194;区</h3>
        <p class="login2-hink">兑换您心仪的礼物</p>
      </div>
      <div class="part2">
        <van-cell-group
          v-if="this.$store.state.exchangeinfo.type==1"
          class="infocont"
          style="background: transparent"
        >
          <div
            class="van-cell van-hairline van-field van-field--has-icon padding15 theme-bd theme-col"
          >
            <div class="van-cell__value">
              <input
                type="text"
                placeholder="卡号/手机号"
                v-model="account"
                @blur="input()"
                class="van-field__control theme-col"
              />
            </div>
          </div>
          <div
            v-if="pwdType==false"
            class="van-cell van-hairline van-field van-field--has-icon padding15 theme-bd theme-col"
          >
            <div class="van-cell__value">
              <input
                type="password"
                placeholder="登录密码"
                v-model="password"
                @blur="input()"
                class="van-field__control theme-col"
              />
            </div>
            <i
              style="color: #FC3D6E"
              @click="changeType()"
              class="van-icon iconfont icon-yanjing-bi inputlabel theme-col"
            ></i>
          </div>
          <div
            v-if="pwdType==true"
            class="van-cell van-hairline van-field van-field--has-icon padding15 theme-bd theme-col"
          >
            <div class="van-cell__value">
              <input
                type="text"
                placeholder="登录密码"
                v-model="password"
                @blur="input()"
                class="van-field__control theme-col"
              />
            </div>
            <i
              style="color: #FC3D6E"
              @click="changeType()"
              class="van-icon iconfont icon-ai-eye inputlabel theme-col"
            ></i>
          </div>
          <div
            v-if="codeshow"
            class="codebox van-cell van-hairline van-field theme-bd theme-col"
            style="padding-right: 0px;"
          >
            <div class="van-cell__value">
              <input
                type="text"
                placeholder="验证码"
                v-model="code"
                @blur="input()"
                class="van-field__control theme-col"
              />
            </div>
            <div class="van-field__button">
              <div class="code" @click="refreshCode">
                <s-identify :identifyCode="identifyCode"></s-identify>
              </div>
            </div>
          </div>
          <van-button size="large" class="theme-bg loginbtn" @click="getNvc()" :loading="loading">登录</van-button>
        </van-cell-group>
        <van-cell-group
          v-if="this.$store.state.exchangeinfo.type==2"
          class="infocont"
          style="background: transparent"
        >
          <div class="van-cell van-hairline van-field van-field--has-icon padding15 theme-bd">
            <div class="van-cell__value">
              <input
                type="number"
                onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"
                @blur="input()"
                placeholder="手机号码"
                v-model="mobile"
                class="van-field__control theme-col"
              />
            </div>
          </div>
          <div style="padding: 3px 15px" class="codebox van-cell van-hairline van-field theme-bd">
            <div class="van-cell__value">
              <input
                type="number"
                placeholder="验证码"
                v-model="code1"
                class="van-field__control theme-col"
              />
            </div>
            <span class="getcode theme-col" @click="getNvc1()" :loading="codeLoading">获取验证码</span>
          </div>
          <van-button
            size="large"
            class="theme-bg loginbtn"
            @click="senData1()"
            :loading="loading"
          >登录</van-button>
        </van-cell-group>
      </div>
    </div>
    <Nvc 
      ref="nverify" 
      :verify="verifyMethods"
    ></Nvc>
  </div>
</template>

<script>
import Nvc from "../login/components/nvc";
import SIdentify from "../../components/identify";
import md5 from "js-md5";
export default {
  name: "index",
  data() {
    return {
      nvctype: 1,
      loading: false,
      datas: "",
      account: "",
      password: "",
      step: 0,
      codeshow: false,
      code: "",
      identifyCodes: "1234567890", //图片验证码
      identifyCode: "", //图片验证码
      pwdType: false, //此时文本框隐藏，显示密码框
      root: process.env.API_ROOT,
      which: 1,
      codeLoading: false,
      mobile: "",
      No: "",
      dd: "",
      code1: "",
      gid: this.$route.query.gid,
      pageheight: document.body.clientHeight,
    };
  },
  components: {
    SIdentify,
    Nvc
  },
  methods: {
    goEegister: function() {
      this.$router.push({ name: "Register", gid: this.gid });
    },
    //密码的显示隐藏
    changeType: function() {
      this.pwdType = !this.pwdType; //跟着小眼睛变化，密码框隐藏显示文本框，内容就显示了
    },
    getNvc() {
      this.password = this.password.toUpperCase();
      if (this.account.length < 5 || this.account.length > 19) {
        this.loading = false;
        this.$toast("卡号/账号有误，请重新输入！");
        this.password = "";
        return
      }
      var reg = new RegExp(/^[0-9a-zA-Z]+$/);
      if (!reg.test(this.password)) {
        this.loading = false;
        this.$toast("密码只能输入数字或字母！");
        this.account = "";
        return
      }

      this.nvctype = 1
      this.$refs.nverify.startVerify()
      
    },
    comit(captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        var mallid = localStorage.getItem("mallid");
        var gid = localStorage.getItem("gid");
        this.loading = true;
        this.$api.post(
          "active/login/user",
          {
            id_active: this.gid,
            account: this.account,
            password: this.password,
            captchaVerifyParam
          },
          res => {
            if (res.data.code == "100") {
              localStorage.setItem("ECuser", res.data.data.token_user);
              this.$store.state.account = res.data.data.account;
              var url = localStorage.getItem("routerUrl1");
              resolve(true)
              if (url != undefined && url != null && url != "") {
                this.$router.push({ name: url, query: { gid: this.gid } }); //跳到路由拦截前的地址
              } else {
                this.$router.push({
                  path: "/eindex",
                  query: { gid: this.gid }
                });
              }
            } else if (
              res.data.code == "400"
            ) {
              this.loading = false;
              resolve(false)
            } else if (res.data.code == "800") {
              this.loading = false;
              this.$toast("登录次数过多请稍后再试");
              resolve(true)
            } else {
              this.loading = false;
              this.$toast(res.data.message);
              resolve(true)
              // this.$toast("服务器繁忙，请稍后再试");
            }
          },
          err => {
            this.loading = false;
            this.$toast(res.data.message);
            // this.$toast("服务器繁忙，请稍后再试");
          }
        );
      })
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    getNvc1: function() {
      const reg = /^[1][3456789][0-9]{9}$/;
      if (!reg.test(this.mobile)) {
        this.$toast("请输入正确的手机号码");
        return false;
      }
      // 进行人机验证
      // this.nvctype = "nvc_message_h5";
      this.nvctype = 2
      this.$refs.nverify.startVerify()
    },
    //短信验证登录
    getCode: function(captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        var _this = this;
        var mallid = localStorage.getItem("mallid");
        var gid = localStorage.getItem("gid");
        if (this.codeLoading == false) {
          this.codeLoading = true;
          this.$api.post(
            "active/message",
            { id_active: this.gid, phone: this.mobile, captchaVerifyParam },
            res => {
              if (res.data.code == "100") {
                this.No = res.data.data;
                var time = 60;
                _this.dd = setInterval(function() {
                  time--;
                  $(".part2 .codebox .getcode").html(time + " s");
                  if (time <= 0) {
                    clearInterval(_this.dd);
                    _this.codeLoading = false;
                    $(".part2 .codebox .getcode").html(
                      '<span class=\\"van-button__text\\">重新发送</span>'
                    );
                  }
                }, 1000);
                _this.codeLoading == false;
                resolve(true)
                this.$toast("发送成功请注意查收");
              } else if (
                res.data.code == "400"
              ) {
                resolve(false)
                _this.codeLoading = false;
              } else if (res.data.code == "800") {
                this.$toast("登录次数过多请稍后再试");
                _this.codeLoading = false;
                resolve(true)
              } else {
                this.$toast(res.data.message);
                _this.codeLoading = false;
                resolve(true)
              }
            }
          );
        }
      })
    },
    senData1: function() {
      this.nvctype = 3
      this.$refs.nverify.startVerify()
    },
    comit2(captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        var mallid = localStorage.getItem("mallid");
        var gid = localStorage.getItem("gid");
        var code = this.No + "_" + this.code1;
        this.loading = true;
        this.$api.post(
          "active/login/phone",
          { id_active: this.gid, phone: this.mobile, code: code, captchaVerifyParam },
          res => {
            if (res.data.code == "100") {
              localStorage.setItem("ECuser", res.data.data.token_user);
              this.$store.state.account = res.data.data.account;
              var url = localStorage.getItem("routerUrl1");
              resolve(true)
              if (url != undefined && url != null && url != "") {
                this.$router.push({ name: url, query: { gid: this.gid } }); //跳到路由拦截前的地址
              } else {
                this.$router.push({ path: "/eindex", query: { gid: this.gid } });
              }
            } else if (
              res.data.code == "400"
            ) {
              resolve(false)
              this.loading = false;
              // this.$refs.nverify.verifyLater(res.data);
            } else {
              resolve(true)
              this.$toast(res.data.message);
            }
            this.loading = false;
          }
        );
      })
      
    },
    input: function() {
      setTimeout(function() {
        window.scrollTo(0, 0);
      }, 100);
    },
    verifyMethods(captchaVerifyParam) {
      return new Promise(async(resolve, reject) => {
        
        switch (this.nvctype) {
          case 1:
            const data = await this.comit(captchaVerifyParam)
            resolve(data)
            break;
          case 2:
            const dataCode = await this.getCode(captchaVerifyParam)
            resolve(dataCode)
            break;
          case 3:
            const dataComit2 = await this.comit2(captchaVerifyParam)
            resolve(dataComit2)
            break;
        }
      })
    }
  },
  mounted() {},
  destroyed: function() {
    clearInterval(this.dd);
    $(".part2 .codebox .getcode").html(
      '<span class=\\"van-button__text\\">获取验证码</span>'
    );
  }
};
</script>

<style lang="less" scoped>
.login2 {
  background: #e7d3bb;
  width: 100%;
  min-height: 100vh;
  background-size: 100% 100%;
  position: relative;
  // input::-webkit-input-placeholder {
  //   color: #FF3B76!important;
  // }
  .topbg {
    width: 28%;
    position: absolute;
    top: 0;
    right: 3%;
    z-index: 90;
  }
  .middlebg {
    width: 100%;
    position: absolute;
    top: 20%;
    right: 0;
    z-index: 30;
  }
  .bottombg {
    width: 75%;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 90;
  }
  .maincont {
    width: 80%;
    z-index: 60;
    position: absolute;
    height: 90vh;
    margin: 5vh 10%;
    .part1 {
      background: url("/static/images/loginmain1.png") no-repeat center;
      background-size: 100% 100%;
      height: 30%;
      width: 100%;
      position: relative;
      text-align: center;
      span {
        display: inline-block;
        width: 25px;
        height: 5px;
        border-radius: 5px;
        background: #fb4068;
        margin: 20px 0 10px 0;
      }
      h2 {
        font-size: 0.32rem;
        color: #fb4068;
      }
      h3 {
        font-size: 0.28rem;
        color: #fc3e6d;
        margin: 10px 0 15px 0;
      }
      .login2-hink {
        display: inline-block;
        padding: 2px 2px;
        border: 1px solid #ff3a7a;
        border-radius: 20px;
        // width: 115px;
        color: #fe3a77;
        font-size: 0.24rem;
        margin: auto;
        margin-top: 5px;
        line-height: 15px;
      } 
    }
    .part1:after {
      content: "";
      position: absolute;
      height: 1px;
      left: 5%;
      right: 5%;
      background: #fff;
      bottom: 0;
      border-bottom: 1px dashed #ffc4d6;
    }
    .part2 {
      width: 100%;
      position: relative;
      height: 70%;
      background: url("/static/images/loginmain2.png") no-repeat center;
      background-size: 100% 100%;
      .infocont {
        width: 90%;
        padding: 0;
        margin-left: 5%;
        position: absolute;
        top: 15%;
        button {
          margin-top: 40px;
        }
      }
    }
  }
  .code {
    /*margin: 400px auto;*/
    width: 114px;
    height: 35px;
  }
  .van-cell-group {
    padding: 0 20px;
  }
  .login_bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 500;
  }
  .van-cell {
    padding: 8px 15px;
    border: 1px solid #ffc4d6;
    border-radius: 40px;
    margin-bottom: 15px;
    color: #ff3b76;
  }
  .login-box {
    /*padding-top: 15vh;*/
    padding-bottom: 8%;
    text-align: center;
    margin-top: -15%;
  }
  .van-button {
    padding: 0;
  }
  .codeimg {
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
  .codebox {
    line-height: 35px;
  }
  .codebox .van-button {
    height: 30px;
    line-height: 30px;
    border: none;
  }
  .loginbtn {
    height: 0.8rem;
    margin-bottom: 15px;
    padding: 0 15px;
    border-radius: 6px;
    // background: linear-gradient(left, #EF5033, #FF397A);
    // color: #fff;
    // background: -webkit-linear-gradient(left, #EF5033, black)!important;
    // background: -o-linear-gradient(left,#EF5033, black)!important;
    // background: -moz-linear-gradient(left,#EF5033,black)!important;
    // background: -ms-linear-gradient(left,#EF5033,#FF397A)!important;
  }
  .restBox {
    border-bottom: none;
  }
  .restBox::after {
    border-bottom-width: 0;
    border-bottom: none;
  }
  .inputlabel {
    vertical-align: middle;
    font-size: 20px;
    margin-right: 15px;
    margin-top: 2px;
  }
  .van-cell__title {
    .iconfont {
      vertical-align: middle;
      font-size: 20px;
      margin-right: 5px;
    }
  }
  .van-cell::after {
    border-bottom: none !important;
  }
}
.theme-bg,
.van-checkbox--checked,
.van-swipe__indicator--active {
  background-color: red !important;
  color: #ffffff !important;
}
.theme-col,
.van-icon-checked {
  color: red !important;
}
.col-hover:hover {
  color: red !important;
}
.col-on {
  color: red !important;
}
.col-focus:focus {
  color: red !important;
}
.col-checked:checked:before {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/exchange/login.vue